import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import CategoriesTable from "components/Admin/Categories/Categories";

import {
  getCategories,
  deleteCategory,
  changeStatusCategory,
} from "store/actions/categories";

const Categories = () => {
  const categoriesData = useSelector((state) => state.categories.categories);
  const dispatch = useDispatch();
  const [page, setPage] = useState(
    categoriesData ? categoriesData.pag.page : 1
  );
  const [amount, setAmount] = useState(
    categoriesData ? categoriesData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    categoriesData ? categoriesData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    categoriesData ? categoriesData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    categoriesData ? categoriesData.pag.search_by : "name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getCategories(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  const deleteHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(deleteCategory(id, pag, history));
  };
  const changeStatusHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(changeStatusCategory(id, pag, history));
  };

  const createHandler = () => {
    history.push("/admin/categories/new-category");
  };

  const updateHandler = (id) => {
    history.push("/admin/categories/category/" + id);
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Categories Table</h4>
        </CardHeader>
        <CardBody>
          {categoriesData && (
            <CategoriesTable
              rows={categoriesData.data}
              totalRows={categoriesData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              //
              deleteHandler={deleteHandler}
              changeStatusHandler={changeStatusHandler}
              createHandler={createHandler}
              updateHandler={updateHandler}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Categories;
